module.exports = __webpack_public_path__ + "img/ainsworth.c6fd0afd.svg";